import { IoTslaLevel, IoTslaStatus } from "../codegen/graphql";

export interface SlaOverride {
    status: string;
    level: string | null;
}

const STATUSES = new Set<string>(Object.values(IoTslaStatus));
const LEVELS = new Set<string>(Object.values(IoTslaLevel));

/**
 * Parses `?slaStatus=INACTIVE[&slaLevel=GOOD]` from a location search string
 * (case-insensitive); null when absent or not a known enum value.
 */
export const parseSlaOverride = (search: string | null | undefined): SlaOverride | null => {
    if (!search) return null;
    const params = new URLSearchParams(search);
    const status = params.get("slaStatus")?.toUpperCase();
    if (!status || !STATUSES.has(status)) return null;
    const level = params.get("slaLevel")?.toUpperCase();
    return { status, level: level && LEVELS.has(level) ? level : null };
};

/**
 * Dev-only override of the asset's SLA status (IBM-1045): open an asset
 * dashboard with `?slaStatus=INACTIVE` (or `ACTIVE&slaLevel=GOOD`,
 * `EVALUATION`, `EVALUATION_FAILED`) to see the SLA chip and the "Start commissioning" button on
 * any industry asset — the dashboard also presents the asset as connected,
 * because testing has no industry asset with an IoT connection that carries
 * an SLA record (the IoT resolver returns null) and no asset at all in
 * INACTIVE. The installed base backend checks neither the connection nor the
 * SLA status, so a commissioning submitted this way creates a real event.
 * Compiled away in production builds (NODE_ENV guard); the e2e specs mock
 * the query instead.
 */
export const readDevSlaOverride = (search: string | null | undefined): SlaOverride | null =>
    process.env.NODE_ENV === "development" ? parseSlaOverride(search) : null;
